module.exports = __webpack_public_path__ + "img/47.4692895d.jpg";